import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const EnterIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M26 6a1 1 0 1 1 2 0v20a1 1 0 1 1-2 0V6Zm-8.636 3.636a1 1 0 1 0-1.414 1.415L19.9 15H7a1 1 0 1 0 0 2h12.9l-3.95 3.95a1 1 0 1 0 1.414 1.414l5.303-5.303a1.5 1.5 0 0 0 0-2.121l-5.303-5.304Z" />
  </BaseIcon>
);
